module.exports = "https://cdn.thelire.com/ins/resource/loading_3.1487e48e9bcc41e18cea39c43191b306.gif";